import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import SelectSearch from '../../../components/SearchGroup/SelectSearch';
import InputSearch from '../../../components/SearchGroup/InputSearch';
import './Search.css';
import { scroller, Element } from 'react-scroll';
import selectTopDecorationImgSrc from '../../../assets/images/HomePage/select_box_top_decoration.svg';
import searchTopDecorationImgSrc from '../../../assets/images/HomePage/search_box_top_decoration.svg';
import searchBottomDecorationImgSrc from '../../../assets/images/HomePage/search_box_bottom_decoration.svg';
import {
    discoveryFetch,
    searchFetch
} from '../../../helper/BookApi';
import MultiSelect from '../../../components/MultiSelect';
import Tile from '../../../components/SearchGroup/SearchTile';
import Flex from '../../../components/Flex';
import MediaQuery from 'react-responsive';
import { isMobile, isDesktop, isLargeDesktop, untilLargeDesktop } from '../../../helper/mediaQueries';
import MoreLessButton from '../../../components/MoreLessButton';
import Collapse from 'material-ui/transitions/Collapse';
import Button from '../../../components/Buttons';

import ActionIcon from '../../../assets/images/DiscoverPage/action.png';
import ComedyIcon from '../../../assets/images/DiscoverPage/comedy.png';
import FamilyIcon from '../../../assets/images/DiscoverPage/family.png';
import FantasyIcon from '../../../assets/images/DiscoverPage/fantasy.png';

let featuredGenres = [
    { label: 'Action/Adventure', value: 'Adventure fiction', icon: ActionIcon, iconSelected: ActionIcon },
    { label: 'Comedy', value: 'Comedy', icon: ComedyIcon, iconSelected: ComedyIcon },
    { label: 'Family/Relationships', value: 'Family/Relationships', icon: FamilyIcon, iconSelected: FamilyIcon },
    { label: 'Fantasy', value: 'Fantasy', icon: FantasyIcon, iconSelected: FantasyIcon },
]

export default class Search extends Component {
    static propTypes = {
        changeSearchStatus: PropTypes.func.isRequired,
        searchStatus: PropTypes.string.isRequired,
        booklistUpdate: PropTypes.func.isRequired,
        bookGenres: PropTypes.array.isRequired,
        challengeLevels: PropTypes.array.isRequired,
    };

    constructor(props) {
        super(props)
        this.state = {
            allGenresOpen: false,
            yearFilter: [],
            genreFilter: [],
            featuredGenresFilter: [],
            nonFeaturedGenresFilter: [],
        }
    }

    componentDidUpdate(prevProps) {
        // only scroll when search status becomes complete
        if (
            prevProps.searchStatus !== this.props.searchStatus &&
            (this.props.searchStatus === 'selectComplete' || this.props.searchStatus === 'inputComplete')
        ) {
            scroller.scrollTo('searchResultAnchor', {
                duration: 800,
                smooth: true,
            })
            const searchResultAnchor = document.getElementById('newSearchLink')
            searchResultAnchor.focus()
        }
    }

    nonFeaturedGenres = () => _.filter(this.props.bookGenres, (item) => {
        return !_.find(featuredGenres, (fg) => _.get(fg, 'value') === _.get(item, 'value'))
    })

    selectSearch = (options) => {
        // this.props.changeSearchStatus('selectComplete') // uncomment for local data
        this.props.changeSearchStatus('resetInput')
        discoveryFetch(options).then((results) => {
            if (results) {
                this.props.booklistUpdate(results, 'selectComplete');
            }
        })
    }

    inputSearch = (searchText) => {
        if (searchText) {
            this.props.changeSearchStatus('resetSelect')
            this.setState({
                yearFilter: [],
                genreFilter: [],
                featuredGenresFilter: [],
                nonFeaturedGenresFilter: [],
            })
            searchFetch(searchText).then((results) => {
                if (results) {
                    this.props.booklistUpdate(results, 'inputComplete');
                }
            })
        }
    }

    selectFields = () => [
        {
            key: 'levels',
            label: 'Challenge Level',
            options: this.props.challengeLevels,
            multiple: true,
            altLabel: 'Pick a challenge level'
        },
        {
            key: 'genres',
            label: 'Genre',
            options: this.props.bookGenres,
            multiple: true,
            altLabel: 'Choose genres'
        }
    ]

    toggleMultiSelect(open) {
        this.setState({
            allGenresOpen: open
        })
    }

    handleYearFilterChange(val) {
        this.setState({ yearFilter: val })
    }

    handleGenreFilterChange(val, key) {
        let { featuredGenresFilter, nonFeaturedGenresFilter } = this.state;
        if (key === 'featured') {
            featuredGenresFilter = val
            this.setState({ featuredGenresFilter })
        } else {
            nonFeaturedGenresFilter = val
            this.setState({ nonFeaturedGenresFilter })
        }
        let genreFilter = _.concat(featuredGenresFilter, nonFeaturedGenresFilter)
        this.setState({ genreFilter })
    }

    onSearch() {
        let { genreFilter, yearFilter } = this.state;
        this.selectSearch({
            genres: genreFilter,
            levels: yearFilter,
        });
    }

    render() {
        return (
            <div className="search__container">
                <MediaQuery query={isMobile}>
                    <div className="search__welcomeMessageMobile">
                        <img className="sr-only" alt="2026 NSW premier's reading challenge" />
                    </div>
                </MediaQuery>
                <MediaQuery query={isDesktop}>
                    <div className="search__welcomeMessageDesktop">
                        <img className="sr-only" alt="2026 NSW premier’s reading challenge" />
                    </div>
                </MediaQuery>

                <div className="search__top">
                    <img className="search__select--image" src={selectTopDecorationImgSrc} alt=""/>
                    <div className="search__select__wrapper">
                        <p className="search__field__title" >Discover books to read</p>
                        <MediaQuery query={isLargeDesktop}>
                            {/* Challenge level */}
                            <Flex align='f'>
                                <Tile title clickDisable>Pick a challenge level</Tile>
                                <MultiSelect
                                    isDisplayTile
                                    isResetSearch={['reset', 'resetSelect'].includes(this.props.searchStatus)}
                                    options={this.props.challengeLevels}
                                    onChange={(val) => this.handleYearFilterChange(val)}
                                />
                            </Flex>
                            {/* Genres level */}
                            <Flex align='f' style={{ paddingTop: 12 }}>
                                <Tile title clickDisable>Choose Genre(s)</Tile>
                                <Flex dir='ttb'>
                                    <Flex align='f' style={{flexGrow: 0, height: 'auto'}} >
                                        <MultiSelect
                                            isResetSearch={['reset', 'resetSelect'].includes(this.props.searchStatus)}
                                            isDisplayTile
                                            options={featuredGenres}
                                            onChange={(val) => this.handleGenreFilterChange(val, 'featured')}
                                        />
                                        <MoreLessButton
                                            highlighted={!!this.state.nonFeaturedGenresFilter.length}
                                            onChange={(v) => this.toggleMultiSelect(v)}
                                        />
                                    </Flex>
                                    <Collapse in={this.state.allGenresOpen} style={{width: '100%'}}>
                                        <Flex align='f'>
                                            <MultiSelect
                                                isDisplayTile={this.state.allGenresOpen}
                                                isResetSearch={['reset', 'resetSelect'].includes(this.props.searchStatus)}
                                                options={this.nonFeaturedGenres()}
                                                onChange={(val) => this.handleGenreFilterChange(val)}
                                                wrap
                                            />
                                        </Flex>
                                    </Collapse>
                                </Flex>
                            </Flex>
                            <Button
                                className="select__desktop--button"
                                color="secondary"
                                variant="raised"
                                onClick={() => this.onSearch()}
                            >
                                Discover
                            </Button>
                        </MediaQuery>
                        {/* mobile discover */}
                        <MediaQuery query={untilLargeDesktop}>
                            <SelectSearch
                                selectFields={this.selectFields()}
                                buttonText="Discover"
                                selectSearchHandler={this.selectSearch}
                                isResetSearch={['reset', 'resetSelect'].includes(this.props.searchStatus)}
                            />
                        </MediaQuery>

                    </div>
                </div>
                {/* mobile input search. submits on enter, onsubmit => false to avoid page reload */}
                <form className="search__bottom" onSubmit={(e) => e.preventDefault()}>
                    <Element name="searchInput" />
                    <img className="search__input--image--top" src={searchTopDecorationImgSrc} alt="" />
                    <img className="search__input--image--bottom" src={searchBottomDecorationImgSrc} alt="" />
                    <div className="search__input__wrapper">
                        <p className="search__field__title">Or just looking for a particular book ?</p>
                        <InputSearch
                            inputSearchHandler={this.inputSearch}
                            isResetSearch={['reset', 'resetInput'].includes(this.props.searchStatus)}
                        />
                    </div>
                </form>
            </div>
        );
    }
}
